// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Model = require("./model");
var React = require("react");
var Apollo = require("./apollo");
var Decoders = require("./decoders");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var OrdreDuJour = require("./ordreDuJour");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var GraphqlQuery = require("./graphqlQuery");
var Configuration = require("./configuration");

var component = ReasonReact.statelessComponent("OrdreDuJourQuery");

function make(graphqlClient, legislature, organe, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.element(/* None */0, /* None */0, GraphqlQuery.make(graphqlClient, Curry._2(Apollo.createOrdreDuJourQuery, legislature, organe), (function (response) {
                        if (typeof response === "number") {
                          return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.LinearProgress[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[])));
                        } else if (response.tag) {
                          console.log("OrdreDuJourQuery error", response[0]);
                          return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), React.createElement("div", undefined, Model.ste("Error")));
                        } else {
                          var ordreDuJour = Decoders.ordreDuJourWrapper(response[0]);
                          return ReasonReact.element(/* None */0, /* None */0, OrdreDuJour.make(legislature, organe, ordreDuJour, /* array */[]));
                        }
                      })));
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/ordreDuJourQuery.re
// module id = 1679
// module chunks = 0